import { FC } from 'react'

export const Container: FC = ({ children }) => {
    return <div className="container">{children}</div>
}

export const ContainerTitle: FC<{ title: string }> = ({ title }) => {
    return <div className="container__title">{title}</div>
}
